angular.module('cerberus.account')

    .factory('organizationGroupsService', function organizationGroupsService(_, $http, $q, $location, apiPath, toaster) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';

        return {
            getMembers:getMembers,
            getMemberOf: getMemberOf,
            getGroupDetails:getGroupDetails,
            getAvailableMembers: getAvailableMembers,
            getAvailableMemberOf: getAvailableMemberOf,
            createOrgGroup: createOrgGroup,
            getGroups: getGroups,
            deleteGroup: deleteGroup,
            deleteGroups: deleteGroups,
            addItem: addItem,
            removeItem: removeItem,
            isUnchanged: isUnchanged,
            updateDetails: updateDetails,
            updateMembers: updateMembers,
            updateMemberOf: updateMemberOf,
            updateOrganizationGroup: updateOrganizationGroup,
            groupModel: groupModel
        };
        ////////////////////

        function groupModel(){
            return {
                details: null,
                members: {
                    current: [],
                    add: [],
                    remove: [],
                    input: []
                },
                memberOf:{
                    current: [],
                    add: [],
                    remove: [],
                    input: []
                }
            };
        }

        function getGroups(orgId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'organizations/' + orgId + '/groups')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function createOrgGroup(id, data){
            var deferred = $q.defer();
            $http.post(apiPath + 'organizations/' + id + '/groups', data)
                .success(function (value) {
                    toaster.pop('success', 'Group created.');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function deleteGroup(id){
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'groups/' + id})
                .success(function(value){
                    deferred.resolve(value);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function deleteGroups(idArray){
            var promises = [];
            for(var i = 0; i < idArray.length; i++){
                promises.push(deleteGroup(idArray[i]));
            }
            return $q.all(promises).then(function(){
                toaster.pop('info', 'Group(s) deleted.');
            });
        }

        function getMemberOf(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'groups/' + id + '/memberOf')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getMembers(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'groups/' + id + '/members')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getGroupDetails(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'groups/' + id)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getAvailableMemberOf(orgId,groupId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'organizations/' + orgId + '/groups/' + groupId + '/available/memberOf')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getAvailableMembers(orgId,groupId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'organizations/' + orgId + '/groups/' + groupId + '/available/members')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function addItem(model,ds) {
            for (var i = 0; i < model.input.length; i++) {
                model.current.push(model.input[i]);
                /* LODASH Version 4 ONLY */
                //var idx = _.findIndex(model.remove, ['id', model.input[i].id]);
                /* NON LODASH OPTION - JAVA NATIVE STYLE */
                var idx = model.remove.map(function(e){ return e.id; }).indexOf(model.input[i].id);
                if (idx > -1) {
                    model.remove.splice(idx, 1);
                }
                else {
                    model.add.push(model.input[i]);
                }
                removeFromArray(ds, model.input[i].id);
            }
            model.input = [];
        }

        function removeItem(model,selected,ds){
            angular.forEach(selected,function(v,k){
                if(v){
                    /* LODASH Version 4 ONLY */
                    //var foundIndex = _.findIndex(model.current, ['id', k]);
                    //var findAddIdx = _.findIndex(model.add, ['id', k]);
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    var foundIndex = _.findIndex(model.current, function(f){return f.id === k;});
                    var findAddIdx = _.findIndex(model.add, function(f){return f.id === k;});
                    if(findAddIdx > -1){
                        model.add.splice(findAddIdx,1);
                    }
                    else{
                        model.remove.push(model.current[foundIndex]);
                    }
                    ds.push(model.current[foundIndex]);
                    model.current.splice(foundIndex,1);
                    selected[k] = false;
                }
            });
        }

        function isUnchanged(temp, orig){
            var isEqualGroup = angular.equals(temp.details, orig.details);
            var isEqualMembers = angular.equals(temp.members.current, orig.members.current);
            var isEqualMemberOf = angular.equals(temp.memberOf.current, orig.memberOf.current);
            return (isEqualGroup && isEqualMembers && isEqualMemberOf);
        }

        function updateMemberOf(id,data){
            var deferred = $q.defer();
            $http.put(apiPath + 'groups/' + id + '/memberOf', data)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function updateMembers(id,data){
            var deferred = $q.defer();
            $http.put(apiPath + 'groups/' + id + '/members', data)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function updateDetails(id,data){
            var deferred = $q.defer();
            $http.put(apiPath + 'groups/' + id, data)
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function updateOrganizationGroup(groupId, data, orig){
            var promises = [];

            //Update name and description
            if(!angular.equals(data.details, orig.details)){
                promises.push(
                    updateDetails(groupId, data.details)
                );
            }

            //Updating members
            if(!angular.equals(data.members.current, orig.members.current)){
                promises.push(
                    updateMembers(groupId,{add:data.members.add, remove:data.members.remove})
                );
            }

            //Updating member of
            if(!angular.equals(data.memberOf.current, orig.memberOf.current)){
                promises.push(
                    updateMemberOf(groupId,{add:data.memberOf.add, remove:data.memberOf.remove})
                );
            }

            return $q.all(promises);
        }

        function removeFromArray(array,id){
            for(var i = 0; i < array.length; i++){
                if(array[i].id === id){
                    array.splice(i,1);
                }
            }
        }
    })
;
